var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".processing-overlay[data-v-02dd265a] {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  border-radius: 0.5rem;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _UserDetails = require("./UserDetails.vue");

var _UserDetails2 = _interopRequireDefault(_UserDetails);

var _UnifiedCheckoutSdk = require("./UnifiedCheckoutSdk.vue");

var _UnifiedCheckoutSdk2 = _interopRequireDefault(_UnifiedCheckoutSdk);

var _UnifiedCheckoutProcessing = require("./UnifiedCheckoutProcessing.vue");

var _UnifiedCheckoutProcessing2 = _interopRequireDefault(_UnifiedCheckoutProcessing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "UnifiedCheckout",
  components: {
    userDetails: _UserDetails2.default,
    UnifiedCheckoutSdk: _UnifiedCheckoutSdk2.default,
    UnifiedCheckoutProcessing: _UnifiedCheckoutProcessing2.default
  },
  props: (0, _defineProperty3.default)({
    logo: {
      type: String,
      required: true
    },
    amount_due: {
      type: [Number],
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    submitting: {
      type: Boolean,
      required: true
    },
    clear_form: {
      type: Boolean,
      required: true,
      default: false
    },
    base_url: {
      type: String,
      required: true
    },
    gateway: {
      type: Object,
      required: true
    },
    csrf_token: {
      type: String,
      required: true
    },
    invoice_no: {
      type: String,
      required: true
    },
    callback_url: {
      type: String,
      required: true
    },
    status_api_url: {
      type: String,
      required: true
    }
  }, "status_api_url", {
    type: String,
    required: true
  }),

  data: function data() {
    return {
      userDetails: {},
      submitting: false,
      clear_form: false,
      formParams: {},
      unifiedCheckoutGateway: {},
      showCheckoutSdk: false,
      jwt: "",
      clientLibrary: "",
      clientLibraryIntegrity: "",
      processingState: null
    };
  },
  mounted: function mounted() {
    this.unifiedCheckoutGateway = JSON.parse(this.gateway);
  },

  methods: {
    handlePaymentResponse: async function handlePaymentResponse(completePaymentDetails) {
      var confirm_api_url = this.base_url + this.unifiedCheckoutGateway.unified_checkout_confirm_url;

      try {
        this.submitting = true;
        this.processingState = "processing";

        var payload = {
          gid: this.unifiedCheckoutGateway.id,
          ref_no: this.invoice_no,
          capture_context: completePaymentDetails.captureContext,
          tt: completePaymentDetails.transientToken
        };

        var response = await Vue.axios.post(confirm_api_url, payload, this.getAuthHeaders());
        var data = response.data;

        if (data && data.success === true) {
          this.processingState = "success";
        } else if (data && data.success === false) {
          this.processingState = "manual";
        } else {
          this.processingState = "manual";
        }
      } catch (error) {
        console.error("Error initializing unified checkout:", error);
        this.processingState = "manual";
      } finally {
        this.submitting = false;
      }
    },
    handleDetails: async function handleDetails(details) {
      this.userDetails = details;
      var trimmedParams = Object.fromEntries((0, _entries2.default)(this.userDetails).map(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (typeof value === "string") {
          return [key, value.trim()];
        }
        return [key, value];
      }));

      this.formParams = trimmedParams;
      this.formParams.gid = this.unifiedCheckoutGateway.id;
      this.formParams.ref_no = this.invoice_no;
      this.formParams.amount = this.amount_due;
      this.formParams.currency = this.currency;
      this.formParams.__csrf_token;
      this.formParams.address = this.userDetails.city + " " + this.userDetails.state + " " + this.userDetails.country;
      var init_api_url = this.base_url + this.unifiedCheckoutGateway.unified_checkout_init_url;

      try {
        this.submitting = true;

        var response = await Vue.axios.post(init_api_url, this.formParams);

        var data = response.data;

        if (data && data.success) {
          this.jwt = data.jwt;
          this.clientLibrary = data.client_library_url;
          this.clientLibraryIntegrity = data.client_library_integrity;

          if (!this.jwt || !this.clientLibrary || !this.clientLibraryIntegrity) {
            throw new Error("Missing required Unified Checkout initialization data.");
          }

          this.showCheckoutSdk = true;
        } else {
          console.error("Initialization failed:", data.message);
        }
      } catch (error) {
        console.error("Error initializing unified checkout:", error);
      } finally {
        this.submitting = false;
      }
    },
    getAuthHeaders: function getAuthHeaders() {
      console.log("CSRF Token:", this.csrf_token);
      return {
        headers: {
          "x-csrf-token": this.csrf_token,
          "Content-Type": "application/json"
        },
        withCredentials: true
      };
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"unifiedCheckoutModal","tabindex":"-1","role":"dialog","aria-labelledby":"unifiedCheckoutModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3 position-relative"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay using Visa / MasterCard")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                    "+_vm._s(_vm.currency)+"\n                    "+_vm._s(_vm.amount_due)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Total Due*")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.amount_due))])]),_vm._v(" "),(!_vm.showCheckoutSdk)?_c('userDetails',{attrs:{"submitting":_vm.submitting,"clear_form":_vm.clear_form},on:{"collecteduserDetails":_vm.handleDetails}}):_vm._e(),_vm._v(" "),(_vm.showCheckoutSdk)?_c('UnifiedCheckoutSdk',{attrs:{"jwt":_vm.jwt,"clientLibrary":_vm.clientLibrary,"clientLibraryIntegrity":_vm.clientLibraryIntegrity},on:{"payment-complete":_vm.handlePaymentResponse}}):_vm._e(),_vm._v(" "),(_vm.processingState)?_c('div',{staticClass:"processing-overlay"},[_c('UnifiedCheckoutProcessing',{attrs:{"state":_vm.processingState,"status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"gateway_id":_vm.unifiedCheckoutGateway.id,"callback_url":_vm.callback_url}})],1):_vm._e()],1)])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
__vue__options__._scopeId = "data-v-02dd265a"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02dd265a", __vue__options__)
  } else {
    hotAPI.reload("data-v-02dd265a", __vue__options__)
  }
})()}